/* eslint-disable no-undef */
export default {
	name: "address-book",
	data() {
		return {
			billingAddress: {},
			shippingAddresses: [],
			shippingAddressHeadings: [
				{
					text: "Site Name",
					field: "siteName"
				},
				{
					text: "Street Address",
					field: "streetAddress"
				},
				{
					text: "City",
					field: "city"
				},
				{
					text: "Postal Code",
					field: "postalCode"
				},
				{
					text: "Contact Person First Name",
					field: "contactFirstName"
				},
				{
					text: "ContactPersonLastName",
					field: "contactLastName"
				},
				{
					text: "Contact Person Phone Number",
					field: "contactPhoneNumber"
				}
			],
			shippingAddressFilter:{
				searchQuery: null,
				activeOrInactiveItems: 1
			},
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			filterStateChanged: false,
			loading: false,
			loadingBillingAddress: false,
			canMakeDeliveryOrders: false,
		};
	},
	methods: {
		getBillingAddress(){
			this.loadingBillingAddress = true;
			customerService.getCompanyBillingAddress().then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.billingAddress = successResponse.data.result;
					}
					this.loadingBillingAddress = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loadingBillingAddress = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getShippingAddress(){
			this.loading = true;
			let request = {
				searchQuery: this.shippingAddressFilter.searchQuery
			};
			customerService.getCompanyShippingAddresses(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.shippingAddresses = successResponse.data.result;
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getOrderTypePermissions(){
			this.loading = true;
			securityService.getOrderTypePermissions().then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.canMakeDeliveryOrders = successResponse.data.canMakeDeliveryOrders;
						if(this.canMakeDeliveryOrders){
							this.getShippingAddress();
						}
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			this.getShippingAddress();
		}
	},
	mounted: function () {
		storeState.setPageTitleAction("Address Book");
		breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Address Book");
		this.getOrderTypePermissions();
		this.getBillingAddress();
	}
};